module.exports = __webpack_public_path__ + "static/media/divinity.c070e765.mp3";